import React, { FunctionComponent } from 'react';

interface ISettlements {}

const Settlements: FunctionComponent<ISettlements> = () => {
  return <></>;
};

export default Settlements;
